import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.market.cases');
import { normalizeSubscriber, formatSubscriberInput, readSubscriberInput } from "src/libs/portal/season/contact-policy";
import { CONTACT_EMAIL_PATTERN } from "src/libs/portal/season/contact-policy";
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { fieldSymbol, PATENT_FIELDS, patentFields, classNumbers, saleMethodLabel } from "src/libs/portal/season/market-catalog";

type RightType = '특허' | '실용신안' | '특허/실용신안' | '상표' | '디자인' | '권리';
type FilterKind = 'patentUtility' | 'trademark' | 'design';
type ListingSort = 'postedAt' | 'registeredAt' | 'appliedAt' | 'priceDesc' | 'priceAsc';
type ClassPickerKind = 'trademark' | 'design';
type AdminConsultStep = 'profile' | 'request' | 'complete';
type AdminAgreementKey = 'privacyAgreed' | 'commissionAgreed';

interface Listing {
    id: string;
    listingType: string;
    isExample?: boolean;
    status: string;
    productName?: string;
    rightType: RightType;
    field: string | string[];
    trademarkClasses?: Array<string | number>;
    designClasses?: Array<string | number>;
    registrationNumber: string;
    registeredAt: string;
    appliedAt?: string;
    ownerName: string;
    title: string;
    summary: string;
    imageUrl: string;
    imageFailed?: boolean;
    price: number | string;
    negotiable: boolean;
    postedAt: string;
    referenceLabel: string;
}

interface FieldOption {
    kind: FilterKind;
    label: string;
    value: string;
}


interface AdminConsultForm {
    companyName: string;
    managerName: string;
    contactPrefix: string;
    contactNumber: string;
    contact: string;
    email: string;
    privacyAgreed: boolean;
    commissionAgreed: boolean;
    desiredPrice: string;
    request: string;
}

@Component({
    selector: 'wiz-page-market-cases',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.market.cases/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

.market-cases-page > div > section {
  padding-top: 18px !important;
}
.market-cases-page main.cases-content {
  display: grid;
  gap: 18px;
}
.market-cases-page main > section.cases-explorer {
  padding: 12px !important;
  border: 1px solid #dbe5e1;
  border-radius: 14px !important;
  background: #fff;
  box-shadow: none !important;
}
.market-cases-page main > section.cases-explorer > div:first-child {
  margin-bottom: 0;
}
.market-cases-page main > section.cases-results {
  margin-top: 0;
}

.cases-link-notice {
  margin: 0;
  padding: 12px 15px;
  border: 1px solid #cbdcc2;
  border-radius: 10px;
  color: #46683b;
  background: #f1f7ec;
  font-size: 12px;
  line-height: 1.7;
}

.cases-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 2px;
}
.cases-header h1 {
  margin: 0;
  color: #173b35;
  font-size: 22px;
  font-weight: 750;
}
.cases-header p {
  margin: 5px 0 0;
  color: #71817b;
  font-size: 12px;
  line-height: 1.6;
}

.cases-consult-action {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #cbdcd3;
  border-radius: 9px;
  color: #275945;
  background: #fff;
  font-size: 12px;
  font-weight: 650;
}
.cases-consult-action svg {
  width: 14px;
  height: 14px;
}
.cases-consult-action:hover {
  background: #eef5ed;
}

.cases-category-tabs,
.cases-field-filters,
.cases-sort-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.cases-category-tabs button {
  min-height: 40px;
  padding: 0 20px;
  border: 1px solid transparent;
  border-radius: 9px;
  color: #60736a;
  background: transparent;
  font-size: 13px;
  font-weight: 650;
}
.cases-category-tabs button:hover {
  background: #f1f6f3;
}
.cases-category-tabs button.is-selected {
  color: #fff;
  background: #173b35;
}

.cases-field-filters {
  position: relative;
  gap: 8px;
  margin-top: 12px;
  padding: 12px 4px 2px;
  border-top: 1px solid #e8eeeb;
}

.cases-filter-caption {
  margin-right: 4px;
  color: #71817b;
  font-size: 11px;
  font-weight: 650;
}

.cases-field-button,
.cases-sort-buttons button {
  min-height: 34px;
  padding: 6px 11px;
  border: 1px solid #e0e8e3;
  border-radius: 8px;
  color: #60736a;
  background: #fff;
  font-size: 11px;
  font-weight: 600;
}
.cases-field-button:hover,
.cases-sort-buttons button:hover {
  border-color: #a8c298;
  background: #f6faf3;
}
.cases-field-button.is-selected,
.cases-sort-buttons button.is-selected {
  border-color: #a8c298;
  color: #386732;
  background: #edf5e7;
}

.cases-class-picker {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  z-index: 40;
  width: min(720px, 100vw - 48px);
  padding: 18px;
  border: 1px solid #dbe5e1;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 18px 48px rgba(23, 59, 53, 0.16);
}

.cases-picker-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.cases-picker-heading h3 {
  margin: 0;
  color: #173b35;
  font-size: 14px;
}
.cases-picker-heading button {
  min-height: 32px;
  padding: 0 10px;
  border: 0;
  border-radius: 6px;
  color: #60736a;
  background: #f1f5f3;
  font-size: 12px;
}

.cases-class-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
}
.cases-class-grid button {
  text-align: left;
}

.cases-results-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.cases-results-heading h2 {
  margin: 0;
  color: #173b35;
  font-size: 18px;
  font-weight: 700;
}

.cases-selected-field {
  margin: 5px 0 0;
  color: #617b6d;
  font-size: 12px;
}

.cases-sort-note,
.cases-list-notice {
  margin: 10px 0 0;
  color: #71817b;
  font-size: 11px;
  line-height: 1.6;
}

.cases-sort-note {
  color: #617b6d;
}

.cases-card-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: stretch;
  gap: 18px;
  margin-top: 14px;
}

.cases-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #dbe5e1;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(25, 58, 52, 0.035);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}
.cases-card:hover {
  border-color: #b2c9b7;
  box-shadow: 0 9px 26px rgba(25, 58, 52, 0.08);
}

.cases-card-visual {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  height: 220px;
  flex-shrink: 0;
  color: #648676;
  background: linear-gradient(135deg, #eef5ef, #f6f9f3);
  text-decoration: none;
}
.cases-card-visual[data-right=상표] {
  color: #a87c88;
  background: linear-gradient(135deg, #f8f0f2, #fdf9fa);
}
.cases-card-visual[data-right=디자인] {
  color: #8381a6;
  background: linear-gradient(135deg, #f0eff8, #f9f8fc);
}

.cases-listing-type {
  position: absolute;
  top: 12px;
  left: 14px;
  z-index: 1;
  padding: 4px 8px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 6px;
  color: #536d60;
  background: rgba(255, 255, 255, 0.8);
  font-size: 10px;
  font-weight: 650;
}

.cases-card-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #fff;
}

.cases-image-empty {
  padding: 20px;
  color: #7b8a82;
  font-size: 12px;
}

.cases-loading,
.cases-error {
  margin-top: 14px;
  padding: 32px 20px;
  border: 1px solid #dbe5e1;
  border-radius: 14px;
  color: #60736a;
  background: #fff;
  text-align: center;
  font-size: 13px;
}

.cases-error p {
  margin: 0 0 12px;
}
.cases-error button {
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #c5d7bc;
  border-radius: 8px;
  color: #386732;
  background: #f4f9ef;
  font-size: 12px;
}

.cases-card-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 17px 18px;
}

.cases-card-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.cases-right-badge {
  padding: 4px 8px;
  border: 1px solid;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 650;
  white-space: nowrap;
}

.cases-posted-date {
  color: #8b9a91;
  font-size: 10px;
}

.cases-card h3 {
  margin: 12px 0 7px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.55;
}
.cases-card h3 a {
  display: -webkit-box;
  overflow: hidden;
  color: #213d31;
  text-decoration: none;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.cases-card h3 a:hover {
  color: #578139;
}

.cases-card-summary {
  display: -webkit-box;
  overflow: hidden;
  margin: 0;
  color: #7b8a82;
  font-size: 11px;
  line-height: 1.8;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.cases-card-field {
  overflow: hidden;
  margin: 12px 0 0;
  color: #5f7d5f;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cases-card-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
  margin: 14px 0 0;
  padding-top: 14px;
  border-top: 1px solid #edf1ee;
}
.cases-card-details div {
  min-width: 0;
}
.cases-card-details dt {
  color: #8b9a91;
  font-size: 10px;
}
.cases-card-details dd {
  overflow-wrap: anywhere;
  margin: 4px 0 0;
  color: #536c5f;
  font-size: 11px;
}

.cases-card-price {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 6px;
  margin-top: auto;
  padding-top: 18px;
}
.cases-card-price > div > span {
  display: block;
  margin-bottom: 4px;
  color: #8b9a91;
  font-size: 10px;
}
.cases-card-price strong {
  display: block;
  color: #173b35;
  font-size: 17px;
  font-weight: 750;
  letter-spacing: -0.04em;
}

.cases-price-negotiable {
  color: #8b9a91;
  font-size: 10px;
}

.cases-card-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #edf1ee;
}
.cases-card-actions a {
  color: #6c8073;
  font-size: 11px;
  text-decoration: none;
}
.cases-card-actions a:hover {
  color: #386732;
}
.cases-card-actions button {
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid #c5d7bc;
  border-radius: 8px;
  color: #386732;
  background: #f4f9ef;
  font-size: 11px;
  font-weight: 650;
}
.cases-card-actions button:hover {
  background: #eaf3e1;
}

.cases-empty {
  margin-top: 14px;
  padding: 48px 20px;
  border: 1px dashed #cbdcd3;
  border-radius: 14px;
  text-align: center;
}
.cases-empty h3 {
  margin: 0;
  color: #536c5f;
  font-size: 15px;
}
.cases-empty p {
  margin: 9px 0 18px;
  color: #8b9a91;
  font-size: 12px;
}
.cases-empty button {
  padding: 9px 14px;
  border: 1px solid #c5d7bc;
  border-radius: 8px;
  color: #386732;
  background: #fff;
  font-size: 12px;
}

.cases-content button:focus-visible,
.cases-content a:focus-visible {
  outline: 2px solid #578139;
  outline-offset: 3px;
}

@media (max-width: 1399px) {
  .cases-card-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 1099px) {
  .cases-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .cases-category-tabs button {
    padding: 0 14px;
  }
}
@media (max-width: 700px) {
  .cases-header {
    align-items: flex-start;
    gap: 10px;
  }
  .cases-header h1 {
    font-size: 20px;
  }
  .cases-header p {
    max-width: 230px;
    font-size: 11px;
  }
  .cases-consult-action {
    padding: 0 9px;
    font-size: 11px;
  }
  .cases-category-tabs {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 3px;
  }
  .cases-category-tabs button {
    padding: 0 3px;
    font-size: 11px;
    white-space: nowrap;
  }
  .cases-class-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .cases-results-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .cases-sort-buttons {
    gap: 5px;
  }
  .cases-sort-buttons button {
    padding: 7px 9px;
  }
  .cases-card-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .cases-card-visual {
    height: 200px;
  }
}
.cases-right-subtabs {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.cases-card-heading {
  padding: 13px 15px;
  border-bottom: 1px solid #edf1ee;
}

.cases-card-topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
  color: #365b4b;
}

.cases-card-topline time {
  color: #7c8c82;
  font-size: 10px;
}

.cases-card-classification {
  display: flex;
  align-items: baseline;
  gap: 7px;
  margin-top: 8px;
  font-size: 11px;
  color: #61786d;
  overflow-wrap: anywhere;
}

.cases-status {
  flex-shrink: 0;
  color: #36734c;
  font-weight: 700;
}

.cases-status.is-negotiating {
  color: #a16c22;
}

.cases-status.is-sold {
  color: #8b8e93;
}

.cases-registration {
  margin: 2px 0 0;
  color: #839087;
  font-size: 11px;
  overflow-wrap: anywhere;
}

.cases-card-actions button:disabled {
  opacity: 0.55;
  cursor: default;
}

.cases-category-tabs button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

@media (max-width: 700px) {
  .cases-category-tabs button {
    flex-direction: column;
    gap: 3px;
    min-height: 56px;
    padding: 5px 2px;
    font-size: 10px;
  }
  .cases-category-tabs .fairy-symbol {
    width: 22px;
    height: 22px;
  }
}
.cases-status.is-example {
  color: #866124;
}`],
})
export class PageMarketCasesComponent implements OnInit {
    public subscriberDisplay = formatSubscriberInput;
    public fieldSymbol = fieldSymbol;
    public selectedSort: ListingSort = 'postedAt';
    public sortOptions: Array<{ value: ListingSort; label: string }> = [
        { value: 'postedAt', label: '등재일(최신)' },
        { value: 'registeredAt', label: '등록일자(최신)' },
        { value: 'appliedAt', label: '출원일자(최신)' },
        { value: 'priceDesc', label: '거래금액 높은 순' },
        { value: 'priceAsc', label: '거래금액 낮은 순' }
    ];
    public contactPrefixes: string[] = ['010', '011', '016', '017', '018', '019'];
    public selectedFilterKind: FilterKind | 'all' | 'brandDesign' = 'all';
    public selectedFilterValue: string = '전체';
    public authModalOpen: boolean = false;
    public authActionLabel: string = '회원 전용 기능';
    public classPickerKind: ClassPickerKind | null = null;
    public adminConsultModalOpen: boolean = false;
    public adminConsultSubmitted: boolean = false;
    public adminConsultSubmitting: boolean = false;
    public adminConsultReceiptNo: string = '';
    public adminConsultStep: AdminConsultStep = 'profile';
    public selectedAdminListing: Listing | null = null;
    public adminConsultForm: AdminConsultForm = this.createAdminConsultForm();

    public patentUtilityFields: FieldOption[] = PATENT_FIELDS.map((field) => ({ kind: 'patentUtility', label: field, value: field }));

    public trademarkClasses: FieldOption[] = [
        { kind: 'trademark', label: '1류(화학제·수지·비료 등)', value: '1류(화학제·수지·비료 등)' },
        { kind: 'trademark', label: '2류(페인트·염료 등)', value: '2류(페인트·염료 등)' },
        { kind: 'trademark', label: '3류(화장품·세정제 등)', value: '3류(화장품·세정제 등)' },
        { kind: 'trademark', label: '4류(공업용 유지·연료 등)', value: '4류(공업용 유지·연료 등)' },
        { kind: 'trademark', label: '5류(의약품·위생용품 등)', value: '5류(의약품·위생용품 등)' },
        { kind: 'trademark', label: '6류(금속재료·금속제품 등)', value: '6류(금속재료·금속제품 등)' },
        { kind: 'trademark', label: '7류(기계·공작기계 등)', value: '7류(기계·공작기계 등)' },
        { kind: 'trademark', label: '8류(수공구·식기류 등)', value: '8류(수공구·식기류 등)' },
        { kind: 'trademark', label: '9류(과학·전기·소프트웨어 등)', value: '9류(과학·전기·소프트웨어 등)' },
        { kind: 'trademark', label: '10류(의료기기·보조기구 등)', value: '10류(의료기기·보조기구 등)' },
        { kind: 'trademark', label: '11류(조명·냉난방·위생설비 등)', value: '11류(조명·냉난방·위생설비 등)' },
        { kind: 'trademark', label: '12류(운송수단·부품 등)', value: '12류(운송수단·부품 등)' },
        { kind: 'trademark', label: '13류(화기·폭죽 등)', value: '13류(화기·폭죽 등)' },
        { kind: 'trademark', label: '14류(귀금속·시계 등)', value: '14류(귀금속·시계 등)' },
        { kind: 'trademark', label: '15류(악기 등)', value: '15류(악기 등)' },
        { kind: 'trademark', label: '16류(종이·인쇄물 등)', value: '16류(종이·인쇄물 등)' },
        { kind: 'trademark', label: '17류(고무·플라스틱 재료 등)', value: '17류(고무·플라스틱 재료 등)' },
        { kind: 'trademark', label: '18류(가죽·가방 등)', value: '18류(가죽·가방 등)' },
        { kind: 'trademark', label: '19류(비금속 건축재료 등)', value: '19류(비금속 건축재료 등)' },
        { kind: 'trademark', label: '20류(가구·비금속 용기 등)', value: '20류(가구·비금속 용기 등)' },
        { kind: 'trademark', label: '21류(가정·주방용품 등)', value: '21류(가정·주방용품 등)' },
        { kind: 'trademark', label: '22류(로프·텐트·섬유원료 등)', value: '22류(로프·텐트·섬유원료 등)' },
        { kind: 'trademark', label: '23류(방적사·실 등)', value: '23류(방적사·실 등)' },
        { kind: 'trademark', label: '24류(직물·침구 등)', value: '24류(직물·침구 등)' },
        { kind: 'trademark', label: '25류(의류·신발·모자 등)', value: '25류(의류·신발·모자 등)' },
        { kind: 'trademark', label: '26류(레이스·단추·장식품 등)', value: '26류(레이스·단추·장식품 등)' },
        { kind: 'trademark', label: '27류(카펫·벽지 등)', value: '27류(카펫·벽지 등)' },
        { kind: 'trademark', label: '28류(게임·완구·운동용품 등)', value: '28류(게임·완구·운동용품 등)' },
        { kind: 'trademark', label: '29류(육류·가공식품 등)', value: '29류(육류·가공식품 등)' },
        { kind: 'trademark', label: '30류(커피·차·과자 등)', value: '30류(커피·차·과자 등)' },
        { kind: 'trademark', label: '31류(농산물·신선식품 등)', value: '31류(농산물·신선식품 등)' },
        { kind: 'trademark', label: '32류(맥주·비알코올음료 등)', value: '32류(맥주·비알코올음료 등)' },
        { kind: 'trademark', label: '33류(주류 등)', value: '33류(주류 등)' },
        { kind: 'trademark', label: '34류(담배·흡연용품 등)', value: '34류(담배·흡연용품 등)' },
        { kind: 'trademark', label: '35류(광고·사업관리 등)', value: '35류(광고·사업관리 등)' },
        { kind: 'trademark', label: '36류(보험·금융·부동산 등)', value: '36류(보험·금융·부동산 등)' },
        { kind: 'trademark', label: '37류(건설·수리업 등)', value: '37류(건설·수리업 등)' },
        { kind: 'trademark', label: '38류(통신업 등)', value: '38류(통신업 등)' },
        { kind: 'trademark', label: '39류(운송·보관·여행업 등)', value: '39류(운송·보관·여행업 등)' },
        { kind: 'trademark', label: '40류(재료처리업 등)', value: '40류(재료처리업 등)' },
        { kind: 'trademark', label: '41류(교육·엔터테인먼트 등)', value: '41류(교육·엔터테인먼트 등)' },
        { kind: 'trademark', label: '42류(과학·기술·디자인 등)', value: '42류(과학·기술·디자인 등)' },
        { kind: 'trademark', label: '43류(음식·숙박업 등)', value: '43류(음식·숙박업 등)' },
        { kind: 'trademark', label: '44류(의료·헬스·조경업 등)', value: '44류(의료·헬스·조경업 등)' },
        { kind: 'trademark', label: '45류(법률·경비·장의업 등)', value: '45류(법률·경비·장의업 등)' }
    ];

    public designClasses: FieldOption[] = [
        { kind: 'design', label: '1류(식품)', value: '1류(식품)' },
        { kind: 'design', label: '2류(의류 및 패션잡화용품)', value: '2류(의류 및 패션잡화용품)' },
        { kind: 'design', label: '3류(여행용품·케이스·개인용품)', value: '3류(여행용품·케이스·개인용품)' },
        { kind: 'design', label: '4류(브러시류)', value: '4류(브러시류)' },
        { kind: 'design', label: '5류(섬유제품·인조천연 시트)', value: '5류(섬유제품·인조천연 시트)' },
        { kind: 'design', label: '6류(가구 및 침구류)', value: '6류(가구 및 침구류)' },
        { kind: 'design', label: '7류(가정용품·주방용품)', value: '7류(가정용품·주방용품)' },
        { kind: 'design', label: '8류(공구·철물류)', value: '8류(공구·철물류)' },
        { kind: 'design', label: '9류(포장용기·운반용기)', value: '9류(포장용기·운반용기)' },
        { kind: 'design', label: '10류(시계·측정기기)', value: '10류(시계·측정기기)' },
        { kind: 'design', label: '11류(장식용품)', value: '11류(장식용품)' },
        { kind: 'design', label: '12류(운송·승강수단)', value: '12류(운송·승강수단)' },
        { kind: 'design', label: '13류(전기 발생·분배·변환기기)', value: '13류(전기 발생·분배·변환기기)' },
        { kind: 'design', label: '14류(기록·통신·정보검색기기)', value: '14류(기록·통신·정보검색기기)' },
        { kind: 'design', label: '15류(기타 기계류)', value: '15류(기타 기계류)' },
        { kind: 'design', label: '16류(사진·영상·광학기기)', value: '16류(사진·영상·광학기기)' },
        { kind: 'design', label: '17류(악기)', value: '17류(악기)' },
        { kind: 'design', label: '18류(인쇄·사무용 기계)', value: '18류(인쇄·사무용 기계)' },
        { kind: 'design', label: '19류(문방구·사무용품·교재)', value: '19류(문방구·사무용품·교재)' },
        { kind: 'design', label: '20류(판매·광고용품·표지판)', value: '20류(판매·광고용품·표지판)' },
        { kind: 'design', label: '21류(게임·완구·스포츠용품)', value: '21류(게임·완구·스포츠용품)' },
        { kind: 'design', label: '22류(무기·화약·사냥·낚시용품)', value: '22류(무기·화약·사냥·낚시용품)' },
        { kind: 'design', label: '23류(유체공급·위생·난방·환기기기)', value: '23류(유체공급·위생·난방·환기기기)' },
        { kind: 'design', label: '24류(의료·실험실용 기기)', value: '24류(의료·실험실용 기기)' },
        { kind: 'design', label: '25류(건축 유닛·건설자재)', value: '25류(건축 유닛·건설자재)' },
        { kind: 'design', label: '26류(조명기기)', value: '26류(조명기기)' },
        { kind: 'design', label: '27류(담배 및 흡연용품)', value: '27류(담배 및 흡연용품)' },
        { kind: 'design', label: '28류(의약품·화장품·위생용품)', value: '28류(의약품·화장품·위생용품)' },
        { kind: 'design', label: '29류(화재·위험방지·구조용품)', value: '29류(화재·위험방지·구조용품)' },
        { kind: 'design', label: '30류(동물관리 및 사육용품)', value: '30류(동물관리 및 사육용품)' },
        { kind: 'design', label: '31류(기타 조리용 기계·기구)', value: '31류(기타 조리용 기계·기구)' }
    ];

    public listings: Listing[] = [];
    public loading: boolean = true;
    public errorMessage: string = '';
    public showListingUpdateNotice: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const query = new URLSearchParams(location.search);
        this.showListingUpdateNotice = query.get('notice') === 'listing-updated';
        const kind = query.get('kind');
        if (['patentUtility', 'brandDesign', 'trademark', 'design'].includes(kind || '')) this.selectedFilterKind = kind as FilterKind | 'brandDesign';
        const field = query.get('field') || '';
        if (this.selectedFilterKind === 'patentUtility' && PATENT_FIELDS.includes(field)) this.selectedFilterValue = field;
        await this.loadListings();
    }


    public async loadListings() {
        if (this.loading && this.listings.length) return;
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const items = new Map<string, Listing>();
            let totalPages = 1;
            for (let page = 1; page <= totalPages; page++) {
                const { code, data } = await wiz.call('get_listings', { page });
                if (code !== 200) throw new Error(data?.message || '공개 사건을 불러오지 못했습니다.');
                for (const item of Array.isArray(data?.items) ? data.items : []) {
                    const listing = this.mapListing(item);
                    if (listing.id) items.set(listing.id, listing);
                }
                totalPages = Math.max(1, Number(data?.pagination?.totalPages) || 1);
            }
            this.listings = Array.from(items.values());
        } catch (error) {
            this.listings = [];
            this.errorMessage = error instanceof Error ? error.message : '공개 사건을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async onImageError(listing: Listing) {
        listing.imageFailed = true;
        await this.service.render();
    }

    public formatDate(value?: string) {
        if (!value) return '미입력';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);
    }

    public get selectedCategoryTitle() {
        if (this.selectedFilterKind === 'patentUtility') return '특허/실용신안';
        if (this.selectedFilterKind === 'trademark') return '상표';
        if (this.selectedFilterKind === 'design') return '디자인';
        if (this.selectedFilterKind === 'brandDesign') return '상표·디자인';
        return '전체 사건';
    }

    public async setSort(sort: ListingSort) {
        this.selectedSort = sort;
        await this.service.render();
    }

    public trackListing(_index: number, listing: Listing) {
        return listing.id;
    }

    public get visibleTrademarkClasses() {
        return [
            this.trademarkClasses[0],
            this.trademarkClasses[1],
            this.trademarkClasses[43],
            this.trademarkClasses[44]
        ];
    }

    public get visibleDesignClasses() {
        return [
            this.designClasses[0],
            this.designClasses[1],
            this.designClasses[29],
            this.designClasses[30]
        ];
    }

    public get filteredListings() {
        let rows = [...this.listings];

        if (this.selectedFilterKind === 'patentUtility') {
            rows = rows.filter((listing) => ['특허', '실용신안', '특허/실용신안'].includes(listing.rightType));
            if (this.selectedFilterValue !== '전체') {
                rows = rows.filter((listing) => patentFields(listing.field).some((field) => patentFields(this.selectedFilterValue).includes(field)));
            }
        }

        if (this.selectedFilterKind === 'trademark') {
            rows = rows.filter((listing) => listing.rightType === '상표');
            if (this.selectedFilterValue !== '전체') {
                rows = rows.filter((listing) => this.listingHasTrademarkClass(listing, this.selectedFilterValue));
            }
        }

        if (this.selectedFilterKind === 'design') {
            rows = rows.filter((listing) => listing.rightType === '디자인');
            if (this.selectedFilterValue !== '전체') {
                rows = rows.filter((listing) => classNumbers([listing.field, ...(listing.designClasses || [])], 31).includes(classNumbers(this.selectedFilterValue, 31)[0]));
            }
        }

        if (this.selectedFilterKind === 'brandDesign') rows = rows.filter((listing) => ['상표', '디자인'].includes(listing.rightType));
        return rows.sort((a, b) => this.compareListings(a, b));
    }

    public formatListingField(listing: Listing) {
        if (listing.rightType === '상표') {
            const numbers = this.listingTrademarkClassNumbers(listing);
            return numbers.length ? numbers[0] + '류' : '류 미입력';
        }
        if (listing.rightType === '디자인') {
            const numbers = classNumbers(listing.field, 31);
            return numbers.length ? numbers[0] + '류' : '류 미입력';
        }
        return patentFields(listing.field).join(', ') || '분야 미입력';
    }

    public listingFieldTitle(listing: Listing) {
        if (listing.rightType === '상표') return this.listingTrademarkClassNumbers(listing).map((n) => n + '류').join(' · ') || '상품류 미입력';
        if (listing.rightType === '디자인') {
            const name = listing.productName || (/\.(png|jpe?g|gif|webp)$/i.test(listing.title) ? '' : listing.title);
            return [this.formatListingField(listing), name].filter(Boolean).join(' ');
        }
        return this.formatListingField(listing);
    }

    public isFieldSelected(field: FieldOption) {
        return this.selectedFilterKind === field.kind && this.selectedFilterValue === field.value;
    }

    public isAllKindSelected(kind: FilterKind) {
        return this.selectedFilterKind === kind && this.selectedFilterValue === '전체';
    }

    public async selectAllByKind(kind: FilterKind | 'brandDesign') {
        this.selectedFilterKind = kind;
        this.selectedFilterValue = '전체';
        this.classPickerKind = null;
        await this.service.render();
    }

    public async selectField(field: FieldOption) {
        if (this.isFieldSelected(field)) {
            await this.selectAllByKind(field.kind);
            return;
        }

        this.selectedFilterKind = field.kind;
        this.selectedFilterValue = field.value;
        await this.service.render();
    }

    public async chooseClassField(field: FieldOption) {
        if (this.isFieldSelected(field)) {
            this.selectedFilterValue = '전체';
        } else {
            this.selectedFilterKind = field.kind;
            this.selectedFilterValue = field.value;
        }

        this.classPickerKind = null;
        await this.service.render();
    }

    public async clearFilter() {
        this.selectedFilterKind = 'all';
        this.selectedFilterValue = '전체';
        this.classPickerKind = null;
        await this.service.render();
    }

    public async openClassPicker(kind: ClassPickerKind) {
        this.classPickerKind = this.classPickerKind === kind ? null : kind;
        await this.service.render();
    }

    public async closeClassPicker() {
        this.classPickerKind = null;
        await this.service.render();
    }

    public async openAdminConsult(listing: Listing) {
        if (listing.isExample || listing.status === '판매완료') return;
        const loggedIn = await this.isLoggedIn();
        if (!loggedIn) {
            this.authActionLabel = '관리자 상담';
            this.authModalOpen = true;
            await this.service.render();
            return;
        }

        this.selectedAdminListing = listing;
        this.adminConsultForm = this.createAdminConsultForm();
        this.adminConsultSubmitted = false;
        this.adminConsultSubmitting = false;
        this.adminConsultReceiptNo = '';
        this.adminConsultStep = 'profile';
        this.adminConsultModalOpen = true;
        await this.service.render();
    }

    public async closeAdminConsult() {
        this.adminConsultModalOpen = false;
        this.selectedAdminListing = null;
        this.adminConsultForm = this.createAdminConsultForm();
        this.adminConsultSubmitted = false;
        this.adminConsultSubmitting = false;
        this.adminConsultReceiptNo = '';
        this.adminConsultStep = 'profile';
        await this.service.render();
    }

    public adminStepClass(step: AdminConsultStep) {
        const order: Record<AdminConsultStep, number> = { profile: 1, request: 2, complete: 3 };
        if (this.adminConsultStep === step) return 'border-cyan-700 bg-cyan-700 text-white';
        if (order[this.adminConsultStep] > order[step]) return 'border-cyan-200 bg-cyan-50 text-cyan-800';
        return 'border-slate-200 bg-white text-slate-500';
    }

    public async goAdminProfileStep() {
        this.adminConsultStep = 'profile';
        await this.service.render();
    }

    public async goAdminRequestStep() {
        if (!(await this.validateAdminProfile())) return;

        this.adminConsultStep = 'request';
        await this.service.render();
    }

    public async toggleAdminAgreement(key: AdminAgreementKey) {
        this.adminConsultForm[key] = !this.adminConsultForm[key];
        await this.service.render();
    }

    public async onAdminContactNumberInput(event: any) {
        const value = readSubscriberInput(event);
        this.adminConsultForm.contactNumber = value;
        event.target.value = value;
        this.syncAdminContact();
        await this.service.render();
    }

    public async submitAdminConsult() {
        const listing = this.selectedAdminListing;
        if (!listing || !this.adminConsultForm.desiredPrice.trim() || !this.adminConsultForm.request.trim()) {
            await this.service.modal.error('특정 지정가와 요청 사항을 입력해주세요.');
            return;
        }
        if (!this.adminConsultForm.privacyAgreed || !this.adminConsultForm.commissionAgreed) {
            await this.service.modal.error('개인정보 및 거래 수수료 동의가 필요합니다.');
            return;
        }

        this.adminConsultSubmitting = true;
        await this.service.render();
        const { code, data } = await wiz.call('submit_consultation', {
            payload: JSON.stringify({
                flow: 'case_consultation',
                data: {
                    requester: { name: this.adminConsultForm.managerName.trim(), company: this.adminConsultForm.companyName.trim() },
                    contact: { phone: this.adminConsultForm.contact, email: this.adminConsultForm.email.trim() },
                    privacyAgreed: this.adminConsultForm.privacyAgreed,
                    feeAgreed: this.adminConsultForm.commissionAgreed,
                    details: {
                        rightId: listing.id,
                        rightTitle: listing.title,
                        registrationNumber: listing.registrationNumber,
                        rightType: listing.rightType,
                        listingType: listing.listingType,
                        price: this.formatPrice(listing.price),
                        desiredPrice: this.adminConsultForm.desiredPrice.trim(),
                        request: this.adminConsultForm.request.trim()
                    }
                }
            })
        });
        this.adminConsultSubmitting = false;
        if (code !== 200) {
            await this.service.modal.error(this.consultationError(data));
            await this.service.render();
            return;
        }

        this.adminConsultReceiptNo = data.receiptNo;
        this.adminConsultSubmitted = true;
        this.adminConsultStep = 'complete';
        this.adminConsultForm = this.createAdminConsultForm();
        await this.service.render();
    }

    public async requestMemberAction(actionLabel: string, returnUrl: string) {
        const loggedIn = await this.isLoggedIn();
        if (loggedIn) {
            location.href = returnUrl;
            return;
        }

        this.authActionLabel = actionLabel;
        this.authModalOpen = true;
        await this.service.render();
    }

    public async closeAuthModal() {
        this.authModalOpen = false;
        await this.service.render();
    }

    public goLogin() {
        location.href = '/access';
    }

    public goSignup() {
        location.href = '/access?view=signup';
    }

    public formatPrice(price: number | string) {
        if (typeof price === 'string') return price;
        return price > 0 ? `${price.toLocaleString()}원` : '특정 지정가 미등록';
    }

    public rightClass(type: RightType) {
        if (type === '특허' || type === '특허/실용신안') return 'bg-cyan-50 text-cyan-700 border-cyan-200';
        if (type === '실용신안') return 'bg-teal-50 text-teal-700 border-teal-200';
        if (type === '상표') return 'bg-rose-50 text-rose-700 border-rose-200';
        if (type === '디자인') return 'bg-indigo-50 text-indigo-700 border-indigo-200';
        return 'bg-slate-50 text-slate-600 border-slate-200';
    }

    private mapListing(item: any): Listing {
        const registrationNumber = String(item.registrationNumber || '').trim();
        return {
            id: String(item.id || '').trim(),
            listingType: saleMethodLabel(item),
            isExample: item.isExample === true,
            status: item.status || '공개중',
            productName: String(item.productName || ''),
            rightType: this.normalizeRightType(String(item.rightType || ''), registrationNumber),
            field: item.field || item.category || '',
            trademarkClasses: Array.isArray(item.trademarkClasses) ? item.trademarkClasses : [],
            designClasses: Array.isArray(item.designClasses) ? item.designClasses : [],
            registrationNumber,
            registeredAt: String(item.registrationDate || ''),
            appliedAt: String(item.applicationDate || ''),
            ownerName: String(item.ownerDisplay || '비공개'),
            title: String(item.title || '권리명 미입력'),
            summary: String(item.summary || ''),
            imageUrl: String(item.imageUrl || ''),
            price: Number(item.price) || 0,
            negotiable: !!item.negotiable,
            postedAt: String(item.publishedAt || ''),
            referenceLabel: '참고자료'
        };
    }

    private normalizeRightType(value: string, registrationNumber: string): RightType {
        const normalized = value.toUpperCase().replace(/\s/g, '');
        if (normalized.includes('상표') || normalized.includes('TRADEMARK')) return '상표';
        if (normalized.includes('디자인') || normalized.includes('DESIGN')) return '디자인';
        const utility = normalized.includes('실용') || normalized.includes('UTILITY');
        const patent = normalized.includes('특허') || normalized.includes('PATENT');
        if (utility && patent) {
            if (registrationNumber.startsWith('20')) return '실용신안';
            if (registrationNumber.startsWith('10')) return '특허';
            return '특허/실용신안';
        }
        if (utility) return '실용신안';
        if (patent) return '특허';
        return '권리';
    }

    private compareListings(a: Listing, b: Listing) {
        const isPriceSort = this.selectedSort === 'priceDesc' || this.selectedSort === 'priceAsc';
        const dateKey = isPriceSort ? 'postedAt' : this.selectedSort as 'postedAt' | 'registeredAt' | 'appliedAt';
        const left = isPriceSort ? this.priceSortValue(a.price) : this.dateSortValue(a[dateKey]);
        const right = isPriceSort ? this.priceSortValue(b.price) : this.dateSortValue(b[dateKey]);

        // Unknown dates and negotiated prices follow entries with a known value.
        if (left === null && right !== null) return 1;
        if (right === null && left !== null) return -1;
        if (left !== null && right !== null && left !== right) {
            return this.selectedSort === 'priceAsc' ? left - right : right - left;
        }
        const postedDifference = (this.dateSortValue(b.postedAt) ?? 0) - (this.dateSortValue(a.postedAt) ?? 0);
        return postedDifference || a.id.localeCompare(b.id);
    }

    private dateSortValue(value?: string): number | null {
        if (!value || !value.trim()) return null;
        const timestamp = Date.parse(value);
        return Number.isFinite(timestamp) ? timestamp : null;
    }

    private priceSortValue(price: number | string): number | null {
        if (typeof price === 'number') return Number.isFinite(price) && price > 0 ? price : null;

        // Existing range labels are ordered by their lower asking price.
        const text = String(price || '').split(/[~～∼]/)[0].replace(/[,\s원]/g, '');
        if (!/^(?:\d+(?:\.\d+)?[억만천백십]*)+$/.test(text)) return null;

        const smallUnits: Record<string, number> = { '천': 1000, '백': 100, '십': 10 };
        const smallValue = (part: string) => {
            let sum = 0;
            const tokens = part.matchAll(/(\d+(?:\.\d+)?)([천백십]?)/g);
            for (const token of tokens) sum += Number(token[1]) * (smallUnits[token[2]] || 1);
            return sum;
        };
        let total = 0;
        let remainder = text;
        for (const [unit, multiplier] of [['억', 100000000], ['만', 10000]] as Array<[string, number]>) {
            const index = remainder.indexOf(unit);
            if (index < 0) continue;
            total += smallValue(remainder.slice(0, index)) * multiplier;
            remainder = remainder.slice(index + 1);
        }
        total += smallValue(remainder);
        return Number.isFinite(total) && total > 0 ? total : null;
    }

    private listingHasTrademarkClass(listing: Listing, selectedField: string) {
        const selectedClass = this.classNumbersFrom(selectedField)[0];
        if (!selectedClass) return false;
        return this.listingTrademarkClassNumbers(listing).includes(selectedClass);
    }

    private listingTrademarkClassNumbers(listing: Listing) {
        const sourceValues: Array<string | number> = [];
        if (Array.isArray(listing.field)) {
            sourceValues.push(...listing.field);
        } else {
            sourceValues.push(listing.field);
        }
        if (Array.isArray(listing.trademarkClasses)) {
            sourceValues.push(...listing.trademarkClasses);
        }

        const unique = new Set<number>();
        sourceValues.forEach((value) => {
            this.classNumbersFrom(value).forEach((classNumber) => {
                if (classNumber >= 1 && classNumber <= 45) unique.add(classNumber);
            });
        });
        return Array.from(unique).sort((a, b) => a - b);
    }

    private classNumbersFrom(value: string | number) {
        if (typeof value === 'number') return [value];

        const text = String(value || '').trim();
        const numbers: number[] = [];
        const pattern = /(\d{1,2})\s*류/g;
        let match: RegExpExecArray | null = null;
        while ((match = pattern.exec(text)) !== null) {
            numbers.push(Number(match[1]));
        }

        if (numbers.length === 0 && /^\d{1,2}$/.test(text)) {
            numbers.push(Number(text));
        }
        return numbers;
    }

    private listingFieldText(listing: Listing) {
        return Array.isArray(listing.field) ? listing.field.join(', ') : String(listing.field || '');
    }

    private async isLoggedIn() {
        try {
            return await this.service.auth.check();
        } catch (error) {
            return false;
        }
    }

    private createAdminConsultForm(): AdminConsultForm {
        return {
            companyName: '',
            managerName: '',
            contactPrefix: '010',
            contactNumber: '',
            contact: '',
            email: '',
            privacyAgreed: false,
            commissionAgreed: false,
            desiredPrice: '',
            request: ''
        };
    }

    private async validateAdminProfile() {
        if (!this.adminConsultForm.companyName.trim() || !this.adminConsultForm.managerName.trim() || !this.adminConsultForm.contactNumber.trim() || !this.adminConsultForm.email.trim()) {
            await this.service.modal.error('회사/성명, 담당자, 연락처, 이메일을 입력해주세요.');
            return false;
        }

        if (normalizeSubscriber(this.adminConsultForm.contactNumber) === null) {
            await this.service.modal.error('연락처는 앞자리를 선택하고 나머지 숫자 8자리를 입력해주세요.');
            return false;
        }

        if (!this.isValidEmail(this.adminConsultForm.email)) {
            await this.service.modal.error('이메일 형식으로 입력해주세요.');
            return false;
        }

        if (!this.adminConsultForm.privacyAgreed || !this.adminConsultForm.commissionAgreed) {
            await this.service.modal.error('필수 동의 항목을 확인해주세요.');
            return false;
        }

        this.syncAdminContact();
        return true;
    }

    private syncAdminContact() {
        const number = normalizeSubscriber(this.adminConsultForm.contactNumber) || '';
        this.adminConsultForm.contact = number.length === 8 ? `${this.adminConsultForm.contactPrefix}-${number.slice(0, 4)}-${number.slice(4)}` : `${this.adminConsultForm.contactPrefix}-${number}`;
    }

    private isValidEmail(email: string) {
        return CONTACT_EMAIL_PATTERN.test((email || '').trim());
    }

    private consultationError(data: any) {
        const message = data?.message || '상담 접수에 실패했습니다.';
        if (data?.errorType === 'validation') return `입력값 오류: ${message}`;
        if (data?.errorType === 'network') return `네트워크 오류: ${message}`;
        return `서버 오류: ${message}`;
    }

    private todayLabel() {
        const now = new Date();
        const year = now.getFullYear();
        const month = `${now.getMonth() + 1}`.padStart(2, '0');
        const date = `${now.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${date}`;
    }
}

export default PageMarketCasesComponent;